.phone-verify-link {
  font-size: 14px;
  &.small {
    font-size: 13px;
  }
}
